import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from '../../core/services/storage.service';
import { StorageVariables } from '../constants/app.enum';

export type Theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly localStorage = inject(StorageService);
  private readonly defaultTheme = 'light';

  private themeSubject = new BehaviorSubject<Theme>(this.getStoredTheme());
  theme$ = this.themeSubject.asObservable();

  initTheme(): void {
    this.applyTheme(this.currentTheme);
  }

  get currentTheme(): Theme {
    return this.themeSubject.value;
  }

  setTheme(theme: Theme): void {
    this.themeSubject.next(theme);
    this.localStorage.set(StorageVariables.THEME, theme);
    this.applyTheme(theme);
  }

  toggleTheme(): void {
    const theme = this.currentTheme === 'light' ? 'dark' : 'light';
    this.setTheme(theme);
  }

  private applyTheme(theme: Theme): void {
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(theme);
  }

  private getStoredTheme(): Theme {
    return (this.localStorage.get(StorageVariables.THEME) as Theme) || this.defaultTheme;
  }
}
